import { makeStyles } from "@material-ui/core";
export default makeStyles((theme) => ({
    homeButton: {
        opacity: 1,
      },
      homeLogo: {
      }
}));
